import { apiCallWithAuthToken } from './config';

export const getStakingGainsByDay = (filter?: ApiFilter) =>
  apiCallWithAuthToken.get<{ count: number; data: StakingGainsByDay[] }>(
    `/staking-gains-by-day/${filter ? `?filter=${JSON.stringify(filter)}` : null}`,
  );
